export const URLMixins = {
    data () {
      return {

      }
    },
    created(){

    },
    methods:{
        makeUrlDomain(type) {
            // make the redirect the URL
            console.log('unified-login makeUrlDomain called: ', type)
            const app_url = process.env.VUE_APP_API_URL
            // const app_url = 'https://staff.ilerno.dev/';
            let full_url = ''
            console.log('app_url: ', app_url)
            let hostname = new URL(app_url).hostname;
            let baseDomain = ''
            console.log('hostname: ', hostname)

            if (hostname == '127.0.0.1' || hostname == 'localhost')
            {
                // CASE: when move to staff portal
                // baseDomain = 'localhost:'+8080
                // full_url = `http://${baseDomain}/`

                // CASE: when register school then use this
                baseDomain = 'localhost:8081'
                full_url = `http://${type}.${baseDomain}/`
            } 
            else 
            {
                let parts = hostname.split('.');

                if (parts.length > 2) {
                    baseDomain = parts.slice(-2).join('.');
                    // ilerno.dev | ilerno.io | ilerno.com
                }
                console.log('parts: ', parts)
                full_url = `https://${type}.${baseDomain}/`
            }

            console.log('full_url: ', full_url)
            return full_url;
        },

        getDomainPart()
        {
            const app_url = process.env.VUE_APP_API_URL

            let domainPart = '';
            let hostname = new URL(app_url).hostname;
            console.log('hostname: ', hostname)

            // hostname = 'staff.ilerno.dev' // testing purpose

            if (hostname == '127.0.0.1' || hostname == 'localhost')
            {
                domainPart = 'localhost'
            }
            else
            {
                let parts = hostname.split('.');

                if (parts.length > 2) {
                    domainPart = parts.slice(-2).join('.');
                    // ilerno.dev | ilerno.io | ilerno.com
                }
            }

            console.log('domainPart: ', domainPart)
            return domainPart;
        },
    }
  }